// src/utils/constantes.js

// Modes de règlement (statiques)
export const MODE_REGLEMENT = [
    { value: 'especes', label: 'Espèces', icon: 'ri-money-cny-circle-line' },
    { value: 'cheque', label: 'Chèque', icon: 'ri-bank-line' },
    { value: 'virement', label: 'Virement', icon: 'ri-bank-card-line' },
    { value: 'carte_bancaire', label: 'Carte bancaire', icon: 'ri-bank-card-2-line' },
    { value: 'traite', label: 'Traite', icon: 'ri-file-copy-line' }
];

// Statuts facture (statiques)
export const STATUT_FACTURE = {
    brouillon: { label: 'Brouillon', color: 'secondary', icon: 'ri-draft-line' },
    emise: { label: 'Émise', color: 'primary', icon: 'ri-send-plane-line' },
    payee_partielle: { label: 'Partiel...', color: 'warning', icon: 'ri-time-line' },
    payee: { label: 'Payée', color: 'success', icon: 'ri-check-double-line' },
    impayee: { label: 'Impayée', color: 'danger', icon: 'ri-error-warning-line' },
    annulee: { label: 'Annulée', color: 'secondary', icon: 'ri-close-circle-line' }
};

// Types facture (statiques)
export const TYPE_FACTURE = {
    normale: { label: 'Facture', color: 'primary' },
    avoir: { label: 'Avoir', color: 'warning' }
};

// Valeurs par défaut des taxes (seront remplacées par les valeurs dynamiques)
export const TAXES_PAR_DEFAUT = {
    TVA_TAUX: 18,
    CSS_TAUX: 1,
    TVA_ACTIVE: true,
    CSS_ACTIVE: true
};

// Exporter avec les valeurs par défaut (pour compatibilité)
export const TVA_TAUX = TAXES_PAR_DEFAUT.TVA_TAUX;
export const CSS_TAUX = TAXES_PAR_DEFAUT.CSS_TAUX;